// src/pages/CompanyPage.jsx
import React from "react";
import { useParams, Link } from "react-router-dom";
import { companiesData } from "../data/companiesData";
import ESGSection from "../components/ESGSection";
import ESGTable from "../components/ESGTable";
import ColorScale from "./ColorScale";
// import ColorTracker from "../components/colortracker";

const CompanyPage = () => {
  const { id } = useParams();
  const company = companiesData.find((c) => c.id === parseInt(id));

  if (!company) {
    return (
      <div style={{ padding: 20 }}>
        <p>Company not found.</p>
        <Link to="/">Back to leaderboard</Link>
      </div>
    );
  }

  return (
    // <div style={{ padding: 20 }}>
    //   <Link to="/">← Back to  companies List</Link>

    //   <div style={{ marginTop: 10 }}>
    //     <h1>{company.name}</h1>
    //     <p>
    //       {company.country} • {company.sector}
    //     </p>
    //     <p style={{ marginTop: 8 }}>{company.description}</p>
    //   </div>

    <div className="company-details">
  <Link to="/" className="back-link">← Back to Companies List</Link>

  <div className="company-info">
    <h1 className="company-name">{company.name}</h1>
    <p className="company-meta">
      {company.country} • {company.sector}
    </p>
    <p className="company-description">{company.description}</p>
  </div>

       
      <ESGSection company={company} />
       <ColorScale/>
      <ESGTable company={company} />
    </div>
  );
};

export default CompanyPage;
